
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class FactCompositeConstituentGrid extends SiteEntityGrid<FactCompositeConstituentRow, any> {
        protected getColumnsKey() { return FactCompositeConstituentColumns.columnsKey; }
        protected getDialogType() { return FactCompositeConstituentDialog; }
        protected getIdProperty() { return FactCompositeConstituentRow.idProperty; }
        protected getInsertPermission() { return FactCompositeConstituentRow.insertPermission; }
        protected getLocalTextPrefix() { return FactCompositeConstituentRow.localTextPrefix; }
        protected getService() { return FactCompositeConstituentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}